import React from "react";
import styled from "styled-components";

const RangeInputContainter = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 20px;
  overflow: hidden;
  margin-top: -2px;
  input {
    position: relative;
    width: 100%;
    z-index: 3;
    background-color: transparent;
    & {
      -webkit-appearance: none;
      width: 100%;
    }
    &:focus {
      outline: none;
    }
    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 10px;
      cursor: pointer;
      animate: 0.2s;
      background-color: transparent;
      border-radius: 1px;
    }
    &::-webkit-slider-thumb {
      border: 1px solid #fff;
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background: #44adf8;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -1px;
      transition: all 0.2s;

      &:hover {
        height: 15px;
        width: 15px;
        margin-top: -3px;
      }
    }
    &::-moz-range-track {
      width: 100%;
      height: 10px;
      cursor: pointer;
      animate: 0.2s;
      background-color: transparent;
      border-radius: 1px;
    }
    &::-moz-range-thumb {
      border: 1px solid #fff;
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background: #44adf8;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -1px;
    }
    &::-ms-track {
      width: 100%;
      height: 10px;
      cursor: pointer;
      animate: 0.2s;
      background-color: transparent;
      border-radius: 1px;
    }
    &::-ms-thumb {
      border: 1px solid #fff;
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background: #44adf8;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -1px;
    }
  }
  &:before {
    z-index: 2;
    content: "";
    display: block;
    position: absolute;
    left: 0;
    background-color: blue;
    top: calc(50% - 2px);
    background-color: #44adf8;
    width: ${props => props.percent}%;
    height: 3px;
  }
  &:after {
    z-index: 1;
    content: "";
    display: block;
    position: absolute;
    right: 0;
    top: calc(50% - 2px);
    background-color: #d9d9d9;
    width: 100%;
    height: 3px;
  }
`;

const RangeInput = ({ value, onChange, max, min, step }) => {
  const getPercent = () => ((value - min) * 100) / (max - min);
  // debugger;

  return (
    <RangeInputContainter percent={getPercent()}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
      />
    </RangeInputContainter>
  )
}

export default RangeInput;